import React, {memo, MutableRefObject, ReactNode} from 'react';
import {ILeafletPolylinePathOptions, PolylineFeatures} from "@ui/leafletCustom/types/polilyne";
import {LeafletEvents} from "@ui/leafletCustom/types/handlers";
import {LatLngCor} from "@ui/leafletCustom/types/latLng";
import {BasePolyline} from "@ui/leafletCustom/leafletPolyline/basePolyline/BasePolyline";


interface IProps<T extends Record<string, any> = any> {
    children?: ReactNode,
    positions: LatLngCor[],
    pathOptions?: ILeafletPolylinePathOptions,
    polylineFeaturesRef?: MutableRefObject<PolylineFeatures>,
    customProperty?: T
    eventHandlers?: LeafletEvents,
}

const LeafletPolyline = memo(<T extends Record<string, any> = any>({
                                children,
                                pathOptions,
                                positions,
                                polylineFeaturesRef,
                                customProperty,
                                eventHandlers,
                            }: IProps<T>)=> {

    return (
        <BasePolyline
            pathOptions={pathOptions}
            positions={positions}
            ref={polylineFeaturesRef}
            customProperty={customProperty}
            eventHandlers={eventHandlers}
        >
            {children}
        </BasePolyline>
    );
})

export default LeafletPolyline;